import React, { useState } from "react";
import {
  FontSizeOutlined,
  UserOutlined,
  FileTextOutlined,
  ShopOutlined,
  PhoneOutlined,
  ClockCircleOutlined,
  NumberOutlined,
  EnvironmentOutlined,
  MobileOutlined,
  WalletOutlined,
  CarOutlined,
  MoneyCollectOutlined,
  QrcodeOutlined,
  PictureOutlined,
  FileImageOutlined,
  BarcodeOutlined,
  TableOutlined,
  UnorderedListOutlined,
  MinusOutlined,
  ColumnHeightOutlined,
  DownOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { Locale } from "../../../../utils";
import { COMPONENT_GROUPS } from "../catalog";
import "./ComponentPalette.scss";

const i18n = Locale.getInstance();

const ICONS = {
  "font-size": FontSizeOutlined,
  user: UserOutlined,
  "file-text": FileTextOutlined,
  shop: ShopOutlined,
  phone: PhoneOutlined,
  "clock-circle": ClockCircleOutlined,
  number: NumberOutlined,
  environment: EnvironmentOutlined,
  mobile: MobileOutlined,
  wallet: WalletOutlined,
  car: CarOutlined,
  "money-collect": MoneyCollectOutlined,
  qrcode: QrcodeOutlined,
  picture: PictureOutlined,
  "file-image": FileImageOutlined,
  barcode: BarcodeOutlined,
  table: TableOutlined,
  "unordered-list": UnorderedListOutlined,
  minus: MinusOutlined,
  "column-height": ColumnHeightOutlined,
};

export default function ComponentPalette({ onAdd }) {
  const [open, setOpen] = useState(() =>
    Object.fromEntries(COMPONENT_GROUPS.map((g) => [g.key, true]))
  );

  return (
    <div className="component-palette">
      <div className="component-palette__title">
        {i18n.t("order.printTemplate.insertComponents")}
      </div>
      {COMPONENT_GROUPS.map((group) => {
        const expanded = open[group.key];
        return (
          <div key={group.key} className="component-palette__group">
            <button
              type="button"
              className="component-palette__group-head"
              onClick={() =>
                setOpen((s) => ({ ...s, [group.key]: !s[group.key] }))
              }
            >
              {expanded ? <DownOutlined /> : <RightOutlined />}
              <span>{i18n.t(group.labelKey)}</span>
            </button>
            {expanded ? (
              <div className="component-palette__items">
                {group.items.map((item) => {
                  const Icon = ICONS[item.icon] || FileTextOutlined;
                  const key = `${item.type}-${item.field || item.variant || item.labelKey}`;
                  return (
                    <button
                      key={key}
                      type="button"
                      className="component-palette__item"
                      onClick={() => onAdd?.(item)}
                    >
                      <Icon />
                      <span>{i18n.t(item.labelKey)}</span>
                    </button>
                  );
                })}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
